import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Steps from "@/components/common/Steps";
import {
  selectCurrentStep,
  setCurrentStep,
} from "@/store/redux/slices/kyc/kyc_setup_slice";
import { selectUserInfo } from "@/store/redux/slices/auth/auth_slice";
import UploadTips from "@/features/account_&_kyc_setup/layout/UploadTips";
import AuthHeader from "@/components/layout/Header/Auth_Header";

const STEPS = [
  { title: "Company Information" },
  { title: "Owner's Information" },
  { title: "Business Information" },
  { title: "Review and Submit" },
];

const getStepFromPath = (pathname = "") => {
  if (pathname.includes("review-and-submit")) return 4;
  if (pathname.includes("step-3")) return 3;
  if (pathname.includes("step-2")) return 2;
  if (pathname.includes("step-1")) return 1;
  return 1;
};

const AccountSetupLayout = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  useSelector(selectUserInfo);
  const reduxStep = useSelector(selectCurrentStep) || 1;

  const currentStep = useMemo(
    () => getStepFromPath(location.pathname),
    [location.pathname]
  );

  useEffect(() => {
    if (currentStep !== reduxStep) {
      dispatch(setCurrentStep(currentStep));
    }
  }, [currentStep, reduxStep, dispatch]);

  return (
    <div className="px-4 sm:px-6 md:px-10">
      <div className="mb-6">
        <AuthHeader
          logoName="VeegilLogo"
          logoSize="small"
          showTitle={false}
          subtitle="Veegil"
          className="p-0 mt-4 md:justify-between"
          containerClassName="px-0"
          showUserGreeting={true}
        />

        <div className="hidden md:flex flex-col items-start gap-2 mt-4">
          <h2 className="text-base font-bold text-primary">
            Setup your new Veegil account
          </h2>
          <p className="text-xs">Takes approximately 10 minutes</p>
        </div>
      </div>

      <div>
        <div>
          <div className="md:hidden">
            <h1 className="mb-2 text-left heading-medium whitespace-nowrap text-primary">
              Onboard your Organization
            </h1>
            <p className="mb-4 text-left text-small text-darkGrey">
              Enter your organization&apos;s information below to continue with
              your account setup.
            </p>
          </div>

          <div className="mb-6 lg:hidden">
            <Steps current={currentStep - 1} steps={STEPS} />
          </div>

          <div className="flex flex-col lg:flex-row lg:gap-20">
            <div className="hidden lg:block">
              <Steps current={currentStep - 1} steps={STEPS} />
              <div className="mt-8">
                <UploadTips />
              </div>
            </div>

            <div className="w-full lg:w-[60%]">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSetupLayout;
